import styled from 'styled-components';

interface IframeVideoPlayerProps {
  src: string;
  title?: string;
  type?: string;
  className?: string;
}

export function IframeVideoPlayer({
  src,
  title,
  type,
  className
}: IframeVideoPlayerProps) {
  return (
    <IframeContainer className={className} _videoType={type}>
      <Iframe src={src} allow="autoplay" title={title} />
    </IframeContainer>
  );
}

const IframeContainer = styled.div<{ _videoType?: string }>`
  height: 0;
  overflow: hidden;
  max-width: 100%;
  padding-bottom: ${({ _videoType }) =>
    _videoType === 'short_video' ? '156.25%' : '56.25%'};

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    background-color: black;
    width: 100%;
    height: 100%;
  }
`;

const Iframe = styled.iframe`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: none;
`;
